import { html } from 'lit';
import componentStyles from './iframe.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export default class Iframe extends OutlineElement {
  static styles = [super.styles, componentStyles];

  static get properties() {
    return {
      title: { type: String },
      url: { type: String },
      height: { type: String },
    };
  }

  firstUpdated() {
    this.wrapper = this.shadowRoot.querySelector('.iframe__wrapper')
    this.wrapper.style.height = this.height ?? '100vh'
    this.wrapper.style.width = '100%'
  }

  render() {
    return html`
      <div class="iframe__wrapper">
        <iframe
          title=${this.title}"
          src="${this.url}"
          frameborder="0"
          loading="lazy"
        ></iframe>
      </div>
    `;
  }
}

customElements.define('hf-iframe', Iframe);
